import React, { useEffect, useRef } from 'react';
import { linkifyPlainText, sanitizeFgtnHtml } from '../../utils/fgtn';

export default function FgtnNotesEditor({ value, onChange }) {
  const editorRef = useRef(null);
  const skipNextValueSync = useRef(false);

  useEffect(() => {
    const el = editorRef.current;
    if (!el) return;
    if (skipNextValueSync.current) {
      skipNextValueSync.current = false;
      return;
    }
    const next = value || '';
    if (el.innerHTML !== next) {
      el.innerHTML = next;
    }
  }, [value]);

  const emitHtml = (html) => {
    skipNextValueSync.current = true;
    onChange(html);
  };

  const handleInput = () => {
    if (!editorRef.current) return;
    emitHtml(editorRef.current.innerHTML);
  };

  const handlePaste = (event) => {
    event.preventDefault();
    const html = event.clipboardData.getData('text/html');
    const text = event.clipboardData.getData('text/plain');
    const cleaned = html ? sanitizeFgtnHtml(html) : linkifyPlainText(text);

    if (document.queryCommandSupported && document.queryCommandSupported('insertHTML')) {
      document.execCommand('insertHTML', false, cleaned);
    } else if (editorRef.current) {
      editorRef.current.innerHTML = `${editorRef.current.innerHTML}${cleaned}`;
    }
    handleInput();
  };

  const handleBlur = () => {
    if (!editorRef.current) return;
    const cleaned = sanitizeFgtnHtml(editorRef.current.innerHTML);
    editorRef.current.innerHTML = cleaned;
    emitHtml(cleaned);
  };

  return (
    <div
      ref={editorRef}
      className="fgtn-editor"
      contentEditable
      suppressContentEditableWarning
      data-placeholder="Paste your OneNote notes here. Links stay clickable."
      onInput={handleInput}
      onPaste={handlePaste}
      onBlur={handleBlur}
      role="textbox"
      aria-multiline="true"
      aria-label="Episode notes"
    />
  );
}
